<template>
    <div>
        <!--login-->
        <el-dialog :visible.sync="loginForm.dialogFormVisible" :width="dialogWidth" title="登录"
                   :append-to-body="true"
                   :modal="true">
            <!-- 通过增加 :append-to-body="true" 解决dialog背景上浮问题
    :modal="true"-->
            <el-form :model="loginForm" label-position="top" ref="loginForm">
                <el-form-item label="手机号" :error="loginForm.phoneError">
                    <el-input placeholder="请输入手机号" v-model="loginForm.phone" @blur="validateLoginPhone"
                              @input="validateLoginPhone" maxlength="11">
                        <template #prepend="">
                            <el-select placeholder="+86" disabled style="width: 80px;"
                                       v-model="loginForm.phonePrefix">
                                <el-option label="+86" value="+86" />
                            </el-select>
                        </template>
                    </el-input>
                </el-form-item>
                <el-form-item label="输入验证码" :error="loginForm.verificationCodeError">
                    <el-input placeholder="请输入验证码" v-model="loginForm.verificationCode"
                              @blur="validateLoginVerificationCode" @input="validateLoginVerificationCode"
                              maxlength="6">
                        <template #append="">
                            <el-button @click="getVerificationCode('loginForm')"
                                       :disabled="loginForm.isCountingDown" type="primary">
                                {{
                        loginForm.verificationButtonText
                                }}
                            </el-button>
                        </template>
                    </el-input>
                </el-form-item>
                <el-form-item>
                    <el-button @click="submitLoginForm" class="w-full bg-primary"
                               type="primary">立即登录</el-button>
                </el-form-item>
            </el-form>
            <p class="text-center mt-4">
                没有账号？
                <el-link type="primary" @click="showRegister">立即注册</el-link>
            </p>
        </el-dialog>
        <!--注册-->
        <el-dialog :visible.sync="form.dialogFormVisible" :width="dialogWidth" title="注册"  :append-to-body="true"
                   :modal="true">
            <el-form :model="form" label-position="top" ref="form">
                <el-form-item label="手机号" :error="form.phoneError">
                    <el-input placeholder="请输入手机号" v-model="form.phone" @blur="validatePhone"
                              @input="validatePhone" maxlength="11">
                        <template #prepend="">
                            <el-select placeholder="+86" disabled style="width: 80px;"
                                       v-model="form.phonePrefix">
                                <el-option label="+86" value="+86" />
                            </el-select>
                        </template>
                    </el-input>
                </el-form-item>
                <el-form-item label="输入验证码" :error="form.verificationCodeError">
                    <el-input placeholder="请输入验证码" v-model="form.verificationCode"
                              @blur="validateVerificationCode" @input="validateVerificationCode" maxlength="6">
                        <template #append="">
                            <el-button @click="getVerificationCode('form')" :disabled="form.isCountingDown"
                                       type="primary">{{ form.verificationButtonText }}</el-button>
                        </template>
                    </el-input>
                </el-form-item>
                <el-form-item label="昵称" :error="form.nicknameError">
                    <el-input placeholder="请输入 20 字符内的昵称" v-model="form.nickname" @blur="validateNickname"
                              @input="validateNickname" maxlength="20"></el-input>
                </el-form-item>
                <el-form-item :error="form.agreementError">
                    <el-checkbox v-model="form.agreement">
                        我已阅读并同意
                        <el-link href="#" type="primary">《用户协议》</el-link>
                        与
                        <el-link href="#" type="primary">《隐私政策》</el-link>
                    </el-checkbox>
                </el-form-item>
                <el-form-item>
                    <el-button @click="submitForm" class="w-full bg-primary" type="primary">立即注册</el-button>
                </el-form-item>
            </el-form>
            <p class="text-center mt-4">
                已有账号？
                <el-link type="primary" @click="showLogin">直接登录</el-link>
            </p>
        </el-dialog>
        <div v-if="isLoggedIn()" class="relative">
            <img alt="User avatar" class="w-10 h-10 rounded-full cursor-pointer " height="40"
                 src="@/assets/user.png" width="40" @mouseover="showUserMenu" />
            <div @mouseleave="hideUserMenu"
                 class="absolute  right-0 mt-2 w-48 bg-white border border-gray-200 rounded-lg shadow-lg"
                 v-show="isUserMenuVisible">
                <a class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100" href="#">
                    {{ user.nickname }}
                </a>
                <a class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100" href="#">
                    {{ user.phone }}
                </a>
                <a class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100" href="#" @click="logout">
                    退出登录
                </a>
            </div>
        </div>
        <div v-else class="flex">
            <button @click="showLogin"
                    class="bg-blue-500 hover:bg-blue-700 text-white font-bold lg:py-2 lg:px-4 rounded   ">
                登录
            </button>
            <button @click="showRegister"
                    class="hidden sm:block ml-5 bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded">
                注册
            </button>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';
    import { jwtDecode } from 'jwt-decode';
    //import { ref } from 'vue';

export default {
    data() {
        return {
            isUserMenuVisible:false,
            user: {},
            registrationMessage:'',
            visitorTryTime: 0,
            loginMessage: '',
            form: {
                dialogFormVisible: false,
                phone: '',
                phonePrefix: '+86',
                verificationCode: '',
                nickname: '',
                birthday: '',
                gender: '',
                invitationCode: '',
                agreement: false,
                phoneError: '',
                verificationCodeError: '',
                nicknameError: '',
                agreementError: '',
                isCountingDown: false,
                countdown: 60,
                verificationButtonText: '获取验证码'
            },
            loginForm: {
                dialogFormVisible: false,
                phonePrefix: '+86',
                phone: '',
                verificationCode: '',
                phoneError: '',
                verificationCodeError: '',
                isCountingDown: false,
                countdown: 60,
                verificationButtonText: '获取验证码'
            },
        };
  },
        computed: {
            dialogWidth() {
                return window.innerWidth <= 768 ? '90%' : '30%';
            }
        },
        methods: {
            isLoggedIn() {
                return !!localStorage.getItem('token');
            },
            showUserMenu() {
                this.isUserMenuVisible = true;
            },
            hideUserMenu() {
                this.isUserMenuVisible = false;
            },
            showRegister() {
                this.loginForm.dialogFormVisible = false;
                this.form.dialogFormVisible = true;
            },
            showLogin() {
                this.form.dialogFormVisible = false;
                this.loginForm.dialogFormVisible = true;
            },
            logout() {
                localStorage.removeItem('token');
                this.user = {};
                this.isLoggedInState = false;
                this.$message({
                    message: '登出成功',
                    type: 'success'
                });
            },
            validatePhone() {
                const phoneRegex = /^[0-9]{11}$/;
                if (!phoneRegex.test(this.form.phone)) {
                    this.form.phoneError = '请输入有效的11位手机号';
                } else {
                    this.form.phoneError = '';
                }
            },
            validateVerificationCode() {
                if (!this.form.verificationCode) {
                    this.form.verificationCodeError = '验证码不能为空';
                } else if (!/^[0-9]{6}$/.test(this.form.verificationCode)) {
                    this.form.verificationCodeError = '请输入6位数字验证码';
                } else {
                    this.form.verificationCodeError = '';
                }
            },
            validateNickname() {
                if (!this.form.nickname) {
                    this.form.nicknameError = '昵称不能为空';
                } else if (this.form.nickname.length > 20) {
                    this.form.nicknameError = '昵称长度不能超过20个字符';
                } else {
                    this.form.nicknameError = '';
                }
            },
            validateAgreement() {
                if (!this.form.agreement) {
                    this.form.agreementError = '请阅读并同意用户协议和隐私政策';
                } else {
                    this.form.agreementError = '';
                }
            },
            saveAuthData(response) {
                // 保存 token 和用户信息到 localStorage
                if (response.data.token) {
                    localStorage.setItem('token', response.data.token);
                }
            },
            async submitForm() {
                this.validatePhone();
                this.validateVerificationCode();
                this.validateNickname();
                this.validateAgreement();
              
                if (this.form.phoneError || this.form.verificationCodeError || this.form.nicknameError || this.form.agreementError) {
                    return;
                }

                try {
                    const payload = {
                        phone: this.form.phone,
                        nickname: this.form.nickname,
                        birthday: this.form.birthday,
                        gender: this.form.gender,
                        verificationCode: this.form.verificationCode
                    };
                    const response = await axios.post('/api/register', payload, {
                        headers: {
                            'Content-Type': 'application/json'
                        }
                    });
                    this.$message({
                        message: response.data.message,
                        type: response.data.type
                    });
                    this.registrationMessage = response.data.message;
                    this.form.dialogFormVisible = false;
                    if (response.data.token) {
                        this.saveAuthData(response);
                        // 查询用户信息
                        await this.checkTokenAndFetchUserInfo();
                    }
                    this.$emit('loginSucc', { username: "xxxx" });
                } catch (error) {
                    console.error('Registration failed:', error);
                    this.registrationMessage = 'Registration failed. Please try again.';
                }
            },
            async submitLoginForm() {
                this.validateLoginPhone();
                this.validateLoginVerificationCode();

                if (this.loginForm.phoneError || this.loginForm.verificationCodeError) {
                    return;
                }

                try {
                    const payload = {
                        phone: this.loginForm.phone,
                        verificationCode: this.loginForm.verificationCode
                    };
                    const response = await axios.post('/api/login', payload, {
                        headers: {
                            'Content-Type': 'application/json'
                        }
                    });
                    this.$message({
                        message: response.data.message,
                        type: response.data.type
                    });
                    console.log('Login successful:', response.data);
                    this.loginMessage = response.data.message;
                    this.loginForm.dialogFormVisible = false;
                    if (response.data.token) {
                        this.saveAuthData(response);
                        // 查询用户信息
                        await this.checkTokenAndFetchUserInfo();
                        this.visitorTryTime = 6;
                       // await this.getAllVisitors();
                    }
                } catch (error) {
                    console.error('Login failed:', error);
                    this.loginMessage = 'Login failed. Please try again.';
                }
            },
            async getVerificationCode(formType) {
                const form = this[formType];
                this.validatePhone();
                if (form.phoneError) {
                    this.$message({
                        message: form.phoneError,
                        type: 'error'
                    });
                    return;
                }

                try {
                    const response = await axios.post('/api/get_verification_code', {
                        phone: form.phone,
                        type: formType === 'form' ? 'register' : 'login'
                    }, {
                        headers: {
                            'Content-Type': 'application/json'
                        }
                    });
                    console.log('Verification code sent:', response.data);
                    this.$message({
                        message: response.data.message,
                        type: response.data.type
                    });
                    this.startCountdown(formType);
                } catch (error) {
                    console.error('Failed to get verification code:', error);
                    this.$message({
                        message: '获取验证码失败，请重试',
                        type: 'error'
                    });
                }
            },
            startCountdown(formType) {
                const form = this[formType];
                form.isCountingDown = true;
                form.countdown = 60;
                form.verificationButtonText = `${form.countdown}s`;
                const interval = setInterval(() => {
                    form.countdown -= 1;
                    if (form.countdown > 0) {
                        form.verificationButtonText = `${form.countdown}s`;
                    } else {
                        clearInterval(interval);
                        form.verificationButtonText = '获取验证码';
                        form.isCountingDown = false;
                    }
                }, 1000);
            },
            async checkTokenAndFetchUserInfo() {
                const token = localStorage.getItem('token');
                if (token) {
                    try {
                        const decodedToken = jwtDecode(token);
                        const currentTime = Date.now() / 1000; // 当前时间的秒数
                        // const expDate = new Date(decodedToken.exp * 1000).toLocaleString();
                        // const currentDate = new Date(currentTime * 1000).toLocaleString();
                        // console.log('Token decoded.exp:', expDate, 'currentTime:', currentDate);

                        if (decodedToken.exp > currentTime) {
                            // Token 未过期，查询用户信息
                            const response = await axios.get(`/api/users/${decodedToken.user_id}`, {
                                headers: {
                                    'Authorization': `Bearer ${token}`
                                }
                            });
                            this.user = response.data;
                            this.isLoggedInState = true;
                        } else {
                            // Token 已过期，清除本地存储
                            localStorage.removeItem('token');
                        }
                    } catch (error) {
                        console.error('Token 解析失败或用户信息查询失败:', error);
                        localStorage.removeItem('token');
                    }
                }
            },
            async updateToken() {
                const token = localStorage.getItem('token');
                if (token) {
                    try {
                        const response = await axios.post('/api/refresh_token', {}, {
                            headers: {
                                'Authorization': `Bearer ${token}`
                            }
                        });
                        const newToken = response.data.token;
                        localStorage.setItem('token', newToken);
                    } catch (error) {
                        console.error('Failed to update token:', error);
                    }
                }
            },
            validateLoginPhone() {
    const phoneRegex = /^[0-9]{11}$/;
    if (!phoneRegex.test(this.loginForm.phone)) {
        this.loginForm.phoneError = '请输入有效的11位手机号';
    } else {
        this.loginForm.phoneError = '';
    }
},
            validateLoginVerificationCode() {
                if (!this.loginForm.verificationCode) {
                    this.loginForm.verificationCodeError = '验证码不能为空';
                } else if (!/^[0-9]{6}$/.test(this.loginForm.verificationCode)) {
                    this.loginForm.verificationCodeError = '请输入6位数字验证码';
                } else {
                    this.loginForm.verificationCodeError = '';
                }
            },
        
  },
};
</script>

<style >
    @media (max-width: 768px) {
        /* 弹窗宽度调整 */
        .el-dialog {
            width: 90% !important;
            max-width: 100%;
        }

        /* 登录/注册表单调整 */
        .el-form-item__label {
            font-size: 14px;
        }

        .el-input__inner {
            height: 40px;
            font-size: 14px;
        }

        .el-button {
            padding: 10px 15px;
            font-size: 14px;
        }

        /* 验证码按钮调整 */
        .el-input-group__append .el-button {
            padding: 0 10px;
        }

        /* 用户菜单调整 */
        .relative {
            position: relative;
        }

        .absolute {
            width: 180px;
            right: 0;
        }

        /* 登录/注册按钮调整 */
        .bg-blue-500 {
            padding: 8px 12px;
            font-size: 14px;
        }

        .ml-5 {
            margin-left: 10px;
        }

        /* 弹窗标题调整 */
        .el-dialog__title {
            font-size: 18px;
        }

        /* 链接文字调整 */
        .el-link {
            font-size: 14px;
        }
    }
</style>